var map = {
	"./": 21971,
	"./App": 9555,
	"./App.js": 9555,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./components/footer": 37501,
	"./components/footer.js": 37501,
	"./components/header": 42569,
	"./components/header.js": 42569,
	"./img/golden-cao-15kg-ad-rpq-carne.webp": 60697,
	"./img/golden-cao-15kg-ad-special.webp": 8956,
	"./img/golden-cao-1kg-ad-rpq-carne.webp": 57410,
	"./img/golden-cao-20kg-ad-special.webp": 35554,
	"./img/golden-cao-3kg-ad-rpq-carne.webp": 33866,
	"./img/golden-gato-10kg-ad-carne.webp": 71788,
	"./img/golden-gato-1kg-ad-carne.webp": 52151,
	"./img/golden-gato-3kg-ad-carne.webp": 28487,
	"./index": 21971,
	"./index.css": 51174,
	"./index.js": 21971,
	"./pages/golden_cao_ad_rpq_carne": 19157,
	"./pages/golden_cao_ad_rpq_carne.js": 19157,
	"./pages/home": 25568,
	"./pages/home.js": 25568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;